var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg2145321432a)" },
      React.createElement("path", { d: "M23.084 4.439l-14.7-3.11a1.16 1.16 0 0 0-1.369.89l-.28 1.795 16.96 3.59.28-1.795a1.16 1.16 0 0 0-.891-1.37zM16.902 7.984a1.17 1.17 0 0 0-1.436-.812l-2.79.774-6.578-1.392-.724 3.418-4.52 1.255a1.17 1.17 0 0 0-.812 1.436l2.547 9.18a1.17 1.17 0 0 0 1.436.811L18.637 18.6a1.17 1.17 0 0 0 .813-1.436l-.438-1.575 1.64.346a1.159 1.159 0 0 0 1.369-.891l1.037-4.9-5.903-1.249-.253-.91zm1.688 4.665l.361-1.707a.477.477 0 0 1 .564-.367l1.708.362c.256.054.42.307.367.563l-.362 1.708a.477.477 0 0 1-.564.367l-1.707-.362a.477.477 0 0 1-.367-.563zm-17.482-.506l4.044-1.122 9.541-2.647 1.027-.286a.22.22 0 0 1 .265.15l.121.434.378 1.361-15.027 4.17-.499-1.794a.219.219 0 0 1 .15-.266zm17.425 5.274a.212.212 0 0 1-.021.164.21.21 0 0 1-.129.102L3.771 21.738a.22.22 0 0 1-.265-.15L2.02 16.234l15.027-4.17.917 3.302.57 2.051z" }),
      React.createElement("path", { d: "M6.133 17.784a.477.477 0 0 0-.586-.331l-1.706.473a.477.477 0 0 0-.331.586l.473 1.706c.07.252.334.401.586.331l1.706-.473a.477.477 0 0 0 .331-.586l-.473-1.706z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg2145321432a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h24v24H0z" })
      )
    )
  );
});